import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { AlarmState } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AlarmStatus',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case AlarmState.AS_ACTION: // 0 初始下单
      return tl('action')
    case AlarmState.AS_CLOSE: // 10 启动指令已下发，订单等待处理
      return tl('close')
  }
  return 'Unknown'
})

const color = computed(() => {
  if (props.state == AlarmState.AS_CLOSE) {
    return '#5A5F6F'
  }
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})